import { HttpError } from "./httpClient"

export const getErrorMessage = (error?: HttpError | Error) => {
	if (!error) return "No details are availble."
	const data = (error as HttpError).data as any
	if ((error as HttpError).data !== undefined && data) {
		if (data.message) {
			return `${data.message}${
				data.error ? ": " + data.error : ""
			}`
		}
		if (
			(error as HttpError).data &&
			((error as HttpError).data as Array<any>).length > 0 &&
			((error as HttpError).data as Array<any>)[0].message
		) {
			return ((error as HttpError).data as Array<any>)[0].message
		}
	}
	if (error.message) return error.message
	return "No details are availble."
}

export const getErrorStatusCode = (error?: HttpError | Error, defaultValue?: number) => {
	if (!error && defaultValue) return defaultValue
	if (!error) return 500
	if ((error as HttpError).status) return (error as HttpError).status
	return 500
}
